<template>
  <label class="switch">
    <input
      :checked="modelValue"
      type="checkbox"
      @input="$emit('update:modelValue', $event.target.checked)"
    />
    <span class="slider"></span>
  </label>
</template>

<script lang="ts">
import { defineComponent } from "vue"

/**
 * A simple on-off switch
 */
export default defineComponent({
  props: {
    /** Models a boolean */
    modelValue: Boolean
  },
})
</script>

<style scoped>
/* adapted from w3schools */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 25px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 25px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 19px;
  width: 19px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  transform: translateX(15px);
}
</style>